import './EmailGate.css';


// ── Új belépő link: a normál belépő ablak kéri (E-mailek 1. kör, FE01) ─────────
// A korábbi újraküldő a nem létező send-confirmation függvényt hívta.

function ResendWidget() {
  return (
    <div className="cp-resend-wrap">
      <button className="eg-submit" onClick={() => { window.location.href = '/'; }}>
        📧 Új belépő link kérése
      </button>
    </div>
  );
}

// ── /confirm-success ──────────────────────────────────────────────────────────

export function ConfirmSuccess() {
  return (
    <div className="eg-overlay">
      <div className="eg-modal eg-modal--return">
        <div className="eg-top-bar" />
        <div className="eg-confirm-inner">
          <div className="eg-title">⚡ KRIPTO TERMINÁL</div>
          <div className="cp-icon">✅</div>
          <div className="cp-heading">Sikeres megerősítés!</div>
          <div className="cp-body">
            Az email-cím megerősítve.<br />Most már beléphetsz a terminálba.
          </div>
          <button className="eg-submit" onClick={() => { window.location.href = '/'; }}>
            ⚡ Belépés a terminálba
          </button>
        </div>
      </div>
    </div>
  );
}

// ── /confirm-error ────────────────────────────────────────────────────────────

export function ConfirmError() {
  return (
    <div className="eg-overlay">
      <div className="eg-modal">
        <div className="eg-top-bar" />
        <div className="eg-confirm-inner">
          <div className="eg-title">⚡ KRIPTO TERMINÁL</div>
          <div className="cp-icon">❌</div>
          <div className="cp-heading">Érvénytelen link</div>
          <div className="cp-body">
            A megerősítő link érvénytelen vagy már felhasználásra került.<br />
            Kérj egy új linket az alábbi gombbal.
          </div>
          <ResendWidget />
          <button className="eg-switch-btn" onClick={() => { window.location.href = '/'; }}>
            ← Vissza a főoldalra
          </button>
        </div>
      </div>
    </div>
  );
}
